import { z } from 'zod'
import { schedulerCronPattern } from '../scheduler'

export const adminProjectsProjectChangeParamsBody = z.object({
  isSendWeeklyReportEnabled: z.boolean().optional(),
  weeklyReportRecipients: z.array(z.string().email()).nullable().optional(),
  weeklyReportSchedule: schedulerCronPattern.optional().nullable(),
})
